<div class="container py-5">
    <div class="row text-center align-items-center">
        <div class="col-lg-3 col-sm-6 mb-4">
            <div class="single-fun-fact">
                <div class="icon mb-2">
                    <i class="fa fa-users fa-2x text-primary"></i>
                </div>
                <h3><span>1.200+</span></h3>
                <p>Zufriedene Fahrschüler</p>
            </div>
        </div>

        <div class="col-lg-3 col-sm-6 mb-4">
            <div class="single-fun-fact">
                <div class="icon mb-2">
                    <i class="fa fa-car fa-2x text-success"></i>
                </div>
                <h3><span>3</span></h3>
                <p>Moderne Ausbildungsfahrzeuge</p>
            </div>
        </div>

        <div class="col-lg-3 col-sm-6 mb-4">
            <div class="single-fun-fact">
                <div class="icon mb-2">
                    <i class="fa fa-clock fa-2x text-warning"></i>
                </div>
                <h3><span>7 Tage</span></h3>
                <p>Theorieunterricht Dauer</p>
            </div>
        </div>

        <div class="col-lg-3 col-sm-6 mb-4">
            <div class="single-fun-fact">
                <div class="icon mb-2">
                    <i class="fa fa-thumbs-up fa-2x text-danger"></i>
                </div>
                <h3><span>100%</span></h3>
                <p>Engagement für deinen Erfolg</p>
            </div>
        </div>
    </div>
</div>
